import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {ActionButton, ProcessResultI} from "../../../infrastructure/interfaces/process-result.interface";
import {TaskI} from "../../../infrastructure/interfaces/task.interface";
import {selectLoadingActionButton} from "../../../infrastructure/store/process-result/process-result.selector";
import {setLoadingActionButton, dispatchActionButton} from "../../../infrastructure/store/process-result/process-result.actions";
import {ProcessI} from "../../../infrastructure/interfaces/process.interface";
import {selectSelectedProcess} from "../../../infrastructure/store/process/process.selector";

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject<void>();

  @Input() processResult: ProcessResultI | TaskI | null = null;

  processModel: ProcessI | null = null;

  loadingActionButton: {button: string, status: boolean} = {button: '', status: false}

  constructor(
    private store: Store,
  ) {
  }

  ngOnInit() {
    // Listen for selected process changes
    this.store.select(selectSelectedProcess).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.processModel = value
    })

    //Listen for loading action button changes
    this.store.select(selectLoadingActionButton).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingActionButton = value;
    })

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dispatchActionButton(buttonId: string) {
    if (!this.loadingActionButton.status) {
      if (this.processModel?.id && this.processResult?.id){
        this.store.dispatch(setLoadingActionButton({
          button: buttonId,
          status: true
        }))

        this.store.dispatch(dispatchActionButton({
          processId: this.processModel.id,
          processResultId: this.processResult.id,
          buttonId: buttonId
        }))
      }
    }
  }

  getActionButtonsSections(): {"section": string, buttons: ActionButton[]}[] {
    if (this.processResult) {
      const sections = this.processResult?.action_buttons.reduce((acc: {[key:string]: ActionButton[]}, curr) => {
        if (Object.keys(acc).includes(curr.section)) {
          acc[curr.section].push(curr);
        }else{
          acc[curr.section] = [curr];
        }
        return acc;
      }, {
        "": []
      })

      return Object.keys(sections).reduce((acc: {"section": string, buttons: ActionButton[]}[], curr) => {
        acc.push({
          section: curr,
          buttons: sections[curr]
        })
        return acc;
      }, [])

    }
    return [];
  }

}
